import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Sirve si recién empiezo la carrera?',
    a: 'Es exactamente para eso. El Megapack está diseñado para ingresantes y estudiantes de primer año. No se asume ningún conocimiento previo. El Tomo 1 empieza desde cero y te lleva de la mano hasta que entendés la lógica del sistema jurídico argentino.'
  }, {
    q: '¿Sirve si ya cursé algunas materias?',
    a: 'Sí. Si ya cursaste pero sentís que hay conceptos que no terminaste de cerrar, el Megapack te sirve para consolidar y conectar lo que ya estudiaste. El Método 360° es especialmente útil si ya tenés base y querés llevarla al siguiente nivel.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después de tu pago recibís un email con el link de descarga. Acceso en menos de 5 minutos. Podés leerlo en el celular, la tablet o la computadora. Compatible con cualquier lector de PDF.'
  }, {
    q: '¿Es material argentino o genérico?',
    a: '100% argentino. Todo el contenido está adaptado al sistema jurídico argentino: CCyC 2015, Constitución Nacional, tratados con jerarquía constitucional, jurisprudencia de la CSJN. No hay referencias a otros países ni a sistemas jurídicos extranjeros.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días con devolución completa sin preguntas. Si abrís el material y no es lo que esperabas, escribís a soporte.tumanualdigital@gmail.com y te devolvemos el 100% del pago. Sin formularios, sin demoras.'
  }, {
    q: '¿Sirve para cualquier facultad de Argentina?',
    a: 'Sí. Las materias del primer año de Abogacía tienen contenidos muy similares en todas las universidades argentinas porque están basadas en el mismo sistema jurídico nacional. El Megapack cubre los contenidos que se cursan en UBA, UNC, UNLP, UNR, UCES, UAI, Siglo 21 y todas las facultades de Derecho del país.'
  }];
  return <section className="py-14 px-4 max-w-3xl mx-auto" data-id="element-111">
      <FadeIn data-id="element-112">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-10 flex items-center justify-center gap-3" data-id="element-113">
          <span className="text-4xl" data-id="element-114">❓</span> LO QUE MÁS NOS PREGUNTAN
        </h2>

        <div className="space-y-4" data-id="element-115">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} data-id="element-116" />)}
        </div>
      </FadeIn>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-gray-800 rounded-xl bg-gray-900/50 overflow-hidden" data-id="element-117">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-118">
        <span className="font-bold text-lg text-gray-200" data-id="element-119">{question}</span>
        <ChevronDown className={`text-amber-500 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} size={20} data-id="element-120" />
      </button>
      <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-121">
        <p className="text-gray-400 leading-relaxed" data-id="element-122">{answer}</p>
      </div>
    </div>;
}